/** Store zustand de conos en uso: colores (amarillo y rojo) y números 1-25 ocupados por empresa/sucursal, con carga, sincronización y reset. */
import { create } from "zustand";
import { GETConosEnUso, normalizarConosEnUso, type ColorCono, type ConosEnUso } from "@/api";

export { type ColorCono } from "@/api";

export const COLORES_CONO: readonly ColorCono[] = ["amarillo", "rojo"] as const;
export const NUMEROS_CONO: readonly number[] = Array.from(
  { length: 25 },
  (_v, i) => i + 1
);

const CONOS_VACIOS: ConosEnUso = { amarillo: [], rojo: [] };

interface ConosEnUsoState {
  enUso: ConosEnUso;
  cargando: boolean;
  cargada: boolean;
  cargar: (codEmpresa?: string, codSucursal?: string, forzar?: boolean) => Promise<void>;
  sincronizar: (conos: ConosEnUso) => void;
  reset: () => void;
}

export const useConosEnUsoStore = create<ConosEnUsoState>((set, get) => ({
  enUso: CONOS_VACIOS,
  cargando: false,
  cargada: false,
  cargar: async (codEmpresa, codSucursal, forzar = false) => {
    if (!forzar && get().cargada) return;
    set({ cargando: true });
    const res = await GETConosEnUso(codEmpresa, codSucursal);
    if (res.success) {
      set({ enUso: normalizarConosEnUso(res.data), cargada: true });
    }
    set({ cargando: false });
  },
  sincronizar: (conos) => set({ enUso: normalizarConosEnUso(conos), cargada: true }),
  reset: () => set({ enUso: CONOS_VACIOS, cargada: false, cargando: false }),
}));